import React from "react";

const DoctorsThought = () => {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    background: 'linear-gradient(to bottom right, #eef5fb, #d0f0f0)',
    position: 'relative',
  };

  const cardStyle = {
    background: 'white',
    borderRadius: '20px',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
    padding: '40px 30px',
    maxWidth: '600px',
    width: '90%',
    textAlign: 'center',
    position: 'relative',
  };

  const iconStyle = {
    fontSize: '60px',
    marginBottom: '20px',
  };

  const headingStyle = {
    fontSize: '36px',
    color: '#003366',
    marginBottom: '10px',
  };

  const dividerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
  };

  const dividerLineStyle = {
    flex: 1,
    height: '2px',
    backgroundColor: '#ccc',
  };

  const subHeadingStyle = {
    color: '#555',
    fontSize: '16px',
  };

  const highlightStyle = {
    fontSize: '40px',
    fontWeight: 'bold',
    color: '#00a699',
    marginBottom: '20px',
  };

  const descriptionStyle = {
    color: '#555',
    fontSize: '18px',
    lineHeight: '1.5',
    marginBottom: '30px',
  };

  const buttonStyle = {
    background: 'linear-gradient(to right, #007acc, #00a699)',
    color: 'white',
    border: 'none',
    padding: '12px 30px',
    borderRadius: '30px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'transform 0.3s',
  };

  const buttonHoverStyle = {
    transform: 'scale(1.05)',
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconStyle}>💡</div>
        <h1 style={headingStyle}>Doctors’ Thoughts</h1>

        <div style={dividerStyle}>
          <span style={dividerLineStyle}></span>
          <p style={subHeadingStyle}>This Section is</p>
          <span style={dividerLineStyle}></span>
        </div>

        <h2 style={highlightStyle}>Under Innovation</h2>

        <p style={descriptionStyle}>
          We are working on bringing expert insights, real experiences, and valuable knowledge to inspire and inform healthcare professionals.
        </p>

        <button
          style={buttonStyle}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          Stay Tuned!
        </button>
      </div>
    </div>
  );
};

export default DoctorsThought;